import { HttpParams } from "@angular/common/http";
import { FiltroSgsia } from "./filtro-sgsia";

export class RevisaoSeloFiltroSgsia extends FiltroSgsia {
    situacoes: Array<any>;
    nrCnpj: string;

    getAsHTTPParams(): HttpParams {
        let params = super.getAsHTTPParams();
        if (this.situacoes != null) {
            this.situacoes.forEach( s => params = params.append("situacoes", s));
        }

        if (this.nrCnpj != null) {
            params = params.set("nrCnpj", this.nrCnpj);
        }

        return params;
    }
}
